<script setup lang="ts">
import { defineEmits } from "vue";

const emits = defineEmits(["menuAction"]);
const action = (index: number) => {
  emits("menuAction", index);
};
</script>

<template>
  <div class="menu-base">
    <el-tooltip effect="dark" content="复制" placement="top"
      ><el-icon :color="`#888888`" @click="action(0)" class="icon" :size="20">
        <CopyDocument />
      </el-icon>
    </el-tooltip>
    <el-tooltip effect="dark" content="重新生成" placement="top">
      <el-icon :color="`#888888`" @click="action(1)" class="icon" :size="20"
        ><Refresh
      /></el-icon>
    </el-tooltip>
  </div>
</template>

<style lang="scss" scoped>
.menu-base {
  display: flex;
  align-items: center;
  gap: 10px;
  height: 34px;
  .icon {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 34px;
    height: 34px;
    cursor: pointer;
    border-radius: 8px;
    &:hover {
      background-color: #eeeeee;
    }
  }
}
</style>
